import React from 'react';
import { useLanguage } from '../components/context/LanguageContext';
import './About.css';

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="about-page">
      <div className="container">
        <div className="about-title-wrapper">
          <h1>{t('aboutUs')}</h1>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2>{t('sportsTourism')}</h2>
            <p>{t('sportsTourismDesc')}</p>
          </section>
          
          <section className="about-section">
            <h2>{t('globalSpecialists')}</h2>
            <p>{t('globalSpecialistsDesc')}</p>
          </section>
          
          <section className="about-section">
            <h2>{t('whatMakesDifferent')}</h2>
            <div className="features-grid">
              <div className="feature">
                <h3>{t('premiumAccess')}</h3>
                <p>{t('premiumAccessDesc')}</p>
              </div>
              <div className="feature">
                <h3>{t('curatedStays')}</h3>
                <p>{t('curatedStaysDesc')}</p>
              </div>
              <div className="feature">
                <h3>{t('seamlessTravel')}</h3>
                <p>{t('seamlessTravelDesc')}</p>
              </div>
              <div className="feature">
                <h3>{t('support247')}</h3>
                <p>{t('support247Desc')}</p>
              </div>
              <div className="feature">
                <h3>{t('localExpertise')}</h3>
                <p>{t('localExpertiseDesc')}</p>
              </div>
              <div className="feature">
                <h3>{t('bestValue')}</h3>
                <p>{t('bestValueDesc')}</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>{t('ourPromise')}</h2>
            <p>{t('ourPromiseDesc')}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;